export const getLongDay = (date, rDay) => {
    const day = rDay < 10 ? '0' + rDay : rDay;
    const rMonth = (date.getMonth() + 1);
    const month = rMonth < 10 ? '0' + rMonth : rMonth;
    const year = date.getFullYear();
    const newDate = new Date(year + '-' + month + '-' + day)
    return newDate.toLocaleDateString('it', {weekday: 'long'}).toUpperCase()
}